// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import AddElementStyled from "./AddElement.styled";

// theme
import { ThemeProvider } from "styled-components";
import ThemeProviderStyled from "../../../theme/ThemeProvider.styled";

const AddElement = props => {
    const { children, click, className, disabled} = props;
    return (
        <ThemeProvider theme={ThemeProviderStyled}>
            <AddElementStyled type="button" disabled={disabled} className={className} onClick={click}>{children}</AddElementStyled>
        </ThemeProvider>
    )
};

AddElement.propTypes = {
    children: PropTypes.node,
    click: PropTypes.func,
    /**
     * Add additional classes
     */
    className: PropTypes.string,
    disabled: PropTypes.bool
};

export default AddElement;
